<div class="wrap">
  <h3>{{data.title}}</h3>
  <p>{{data.text}}</p>
  <div class="btn_action">
    <button class="back" (click)="dialogRef.close()">Annuler</button>
    <button class="confirm" (click)="confirmAction()" appChangeColorTheme attribute="bgc">Confirmer</button>
  </div>

</div>
